import dev from './config.dev'
import docker from './config.docker'
import dockerlan from './config.dockerlan'

let cfg:Conifg = {
  baseUrl: '',
  showIcp: false
}

// 各环境配置文件
if(process.env.REACT_APP_ENV === 'dev'){
  cfg = dev
}else if(process.env.REACT_APP_ENV === 'docker'){
  cfg = docker
}else if(process.env.REACT_APP_ENV === 'dockerlan'){
  cfg = dockerlan
}

export default cfg